import { isPlatformBrowser } from '@angular/common';
import {
  inject,
  makeEnvironmentProviders,
  PLATFORM_ID,
  provideAppInitializer,
} from '@angular/core';
import { ThemeSwitcherService } from './theme-switcher.service';

export const provideThemeInitializer = () => {
  return makeEnvironmentProviders([
    provideAppInitializer(() => {
      const isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

      if (!isBrowser) {
        return;
      }

      // no-op, just to ensure the service is instantiated
      const themeService = inject(ThemeSwitcherService);
    }),
  ]);
};
